export const instrumentationKeys: { [key: string]: { [key: string]: string } } = {
  'ikea.com': {
    // PROD
    ae: '86d3bbe8-dd38-4d16-8f93-e7cc956589c0',
    cl: '019e16c4-de79-427d-84d6-391bb1254bad',
    co: 'a393d811-b614-46ae-8c41-82168bf901dd',
    eg: '8b0ed655-c0df-4db5-8cd7-acc397f62e8b',
    il: 'b6fb6c02-83da-478a-a04d-fd181f7ca08d',
    jo: 'd419dbc1-5649-4dda-bbf5-40695bcb4f89',
    kw: '91a8eb0c-ddca-4774-85cc-832b6ef55313',
    ma: '0bf80e66-8782-4f90-bc39-498299ddf3d3',
    mx: '50535f0f-43d9-40f5-ad04-f652290f7f3b',
    my: 'baaf566c-85d6-49aa-8d3b-1f74dbcfd864',
    om: 'fbf84485-c6cf-41ca-827e-83516f4c7c7a',
    ph: 'aa0fcc39-2988-4841-bfb5-eb1e9eee4d52',
    qa: '18be77f3-4227-4548-b660-1591b2a565e3',
    sg: 'd7d626e9-51a9-4d93-ba14-8955bf3a5ccf',
    th: '89b033d2-fb77-4c2b-b0cb-475a9b187fc3',
  },
  'ikeadt.com': {
    // QA
    ae: '4f16009e-bd8c-4f2d-8bb0-64d2d8c97454',
    cl: '3941f512-9c40-4c1f-a96e-1138cee2c9c3',
    co: 'ad9f954b-b339-4392-939d-e3f4204537e5',
    eg: '59766286-5f3a-43e3-b95e-b982bb264b9b',
    il: '4c7c72a9-fd85-44bd-baed-6c58c1e5c72b',
    jo: '3518a388-3c01-4bd0-ac7c-5016c6882edd',
    kw: '1aef625b-c6f5-492d-9d30-c4d468f24973',
    ma: '9c250e5a-4b76-437d-ad09-39d36355ba0d',
    mx: '7c35ac55-c334-4616-a2c3-cb265c09cdcb',
    my: '66226c3f-f43f-47e9-90fc-8d79df3daa1c',
    om: '024abe95-d7d3-4de1-8ab0-3108ded8376c',
    ph: '7d4ce395-50c9-49c2-8467-4da9e7644f21',
    qa: '8e4dfd59-c4f0-47b0-9510-1da34122bfba',
    sg: 'bcb881ef-c465-4d77-9c2d-4b7ccf5c27a4',
    th: '61fb08ab-b9c2-4907-b236-8a6b19a35f64',
  },
};
